import * as React from 'react'
import { io } from 'socket.io-client'
import InterviewChat from '../components/primitives/InterviewChat'
export default function InterviewPage({ sessionId }: { sessionId: string }) {
  const [messages, setMessages] = React.useState<
    { role: 'agent' | 'candidate'; content: string }[]
  >([])
  const [input, setInput] = React.useState('')
  const [typing, setTyping] = React.useState(false)
  const sockRef = React.useRef<any>(null)
  React.useEffect(() => {
    const sock = io('/interview')
    sock.emit('join', { sessionId })
    sock.on('agent:typing', (v: boolean) => setTyping(v))
    sock.on('agent:message', (d: any) => {
      setMessages((m) => {
        const last = m[m.length - 1]
        if (last && last.role === 'agent') {
          const copy = [...m]
          copy[copy.length - 1] = { role: 'agent', content: last.content + (d.chunk || '') }
          return copy
        }
        return [...m, { role: 'agent', content: d.chunk || '' }]
      })
    })
    sock.on('session:ended', () =>
      setMessages((m) => [...m, { role: 'agent', content: 'Interview complete. Thank you!' }])
    )
    sockRef.current = sock
    return () => sock.disconnect()
  }, [sessionId])
  const onSend = () => {
    if (!input.trim()) return
    setMessages((m) => [...m, { role: 'candidate', content: input }])
    sockRef.current?.emit('candidate:message', { sessionId, text: input })
    setInput('')
  }
  const onEnd = () => sockRef.current?.emit('session:end', { sessionId })
  return (
    <div className="max-w-3xl mx-auto p-6">
      <h2 className="text-2xl font-semibold mb-4">Interview</h2>
      <InterviewChat
        messages={messages}
        typing={typing}
        input={input}
        setInput={setInput}
        onSend={onSend}
        onEnd={onEnd}
      />
    </div>
  )
}
